import React, { FC, memo } from 'react'
import * as S from './styles'
import { TextProps } from './types'

export const Text: FC<TextProps> = memo(
  ({
    as = 'p',
    color = 'normal',
    size = 'sm',
    family = 'text',
    align = 'unset',
    weight = 'normal',
    italic = false,
    underline = false,
    transform = 'none',
    margin = '',
    padding = '',
    ellipsis = false,
    lineHeight,
    children,
    ...rest
  }) => (
    <S.Text
      as={as}
      color={color}
      size={size}
      family={family}
      align={align}
      weight={weight}
      italic={italic}
      underline={underline}
      transform={transform}
      margin={margin}
      padding={padding}
      ellipsis={ellipsis}
      lineHeight={lineHeight}
      {...rest}
    >
      {children}
    </S.Text>
  )
)

Text.displayName = 'Text'
